import AgenteContabilidadeRedirect from "./AgenteContabilidadeRedirect";
import AjudaPage from "./AjudaPage";
import CarteiraRecebiveisPage from "./CarteiraRecebiveisPage";
import CustosPage from "./CustosPage";
import DespesasPage from "./DespesasPage";
import DreViabilidadePage from "./DreViabilidadePage";
import ImportacaoPage from "./ImportacaoPage";
import ImpostosPage from "./ImpostosPage";
import VendasPage from "./VendasPage";
import VisaoGeralPage from "./VisaoGeralPage";

export const AgenteContabilidadeCarteiraRecebiveis = CarteiraRecebiveisPage;
export const AgenteContabilidadeAjuda = AjudaPage;
export const AgenteContabilidadeCustos = CustosPage;
export const AgenteContabilidadeDespesas = DespesasPage;
export const AgenteContabilidadeDreViabilidade = DreViabilidadePage;
export const AgenteContabilidadeImportacao = ImportacaoPage;
export const AgenteContabilidadeImpostos = ImpostosPage;
export const AgenteContabilidadeVendas = VendasPage;
export const AgenteContabilidadeVisaoGeral = VisaoGeralPage;

export { AgenteContabilidadeRedirect };

export default AgenteContabilidadeRedirect;

